export enum PaymentTerms {
  Days14 = 14,
  Days21 = 21,
  Days30 = 30,
  Days45 = 45,
  Days60 = 60,
}
